<template>
  <div class="position-relative">
    <v-app class="p-4">
      <!--        <ads-selector></ads-selector>-->
      <div class="p-0 " style="border: none!important;">
        <category-market :edit="false" :page-name="namePage" :phone="this.schema.advertise.contact.phone"
                         @category-schema="getSchema"
                         @category-fields="getFields"
                         :fields="fields"
                         @category-current="getCurrent" ref="category"
                         :multiAdsCat="false"></category-market>

        <div class="col-md-11 mx-auto">
          <div class="col-md-8 pt-0 mx-auto px-0" v-if="!auto_change && schema.advertise.category !== '' ">
            <get-panels-number ref="number" :current="schema.advertise.category" :multiple-numbers="false"
                               panel-type="divar_shop"></get-panels-number>
          </div>

          <div class="col-md-8 pt-0 mx-auto px-0" v-if="!auto_change">
            <pic-selector :count="10"></pic-selector>
          </div>
        </div>

        <div class="px-5 mx-1 pt-0 ">
          <input-maker :param="schema.advertise"
                       ref="inputs"
                       :ui_schema="this.ui_schema"
                       :fields="this.fields"></input-maker>
        </div>

        <setting-ads :market="true" v-if="!auto_change" class="mt-0 py-0 my-0"></setting-ads>

        <div class="col-md-8 mr-auto" v-if="!auto_change">
          <v-btn class="btn submit-btn float-left" @click="authenticate">
            <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
            ثبت آگهی
          </v-btn>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import CitySelector from "@/view/pages/ads/citySelector";
import Automatics from "@/view/pages/ads/timeHandelers/automatics";
import AdsSelector from "@/view/pages/ads/adsSelector";
import InputMaker from "@/view/pages/ads/inputMaker";
import SettingAds from "@/view/pages/ads/settingAds";
import PicSelector from "@/view/pages/uploadCenter/picSelector";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import {Axios2, Bus} from "@/main";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";
import PublicButton from "@/view/pages/uiBeautifier/buttonTempl";
import ExtraButtons from "@/view/pages/uiBeautifier/extraButtons";
import GetPanelsNumber from "../agency/getPanelsNumber";
import Categoryselector from "@/view/pages/ads/categorySelector";
import CategoryMarket from "@/view/pages/ads/panels/categoryMarket";

export default {
  name: "marketSendAds",
  components: {
    CategoryMarket,
    Categoryselector,
    GetPanelsNumber,
    ExtraButtons,
    PublicButton,
    ButtonTempl,
    TitleRibbon,
    PicSelector,
    SettingAds,
    InputMaker,
    AdsSelector,
    Automatics,
    CitySelector,
  },
  props: {
    ui_schema: {
      type: Array,
      default() {
        return []
      }
    },
    auto_change: {
      default: false
    },
    deActive: {
      default: false
    },
  },
  data() {
    return {
      picker: '',
      submitMessage: '',
      namePage: this.pageName,
      current: '',
      isNational: false,
      fields: [],
      relatedCities: '',
      schema: {
        advertise: {
          category: "",
          location: {},
          images: [],
          contact: {
            chat_enabled: true,
            hide_phone: false,
            phone: null
          },
        },
        available_at: '',
        expire_at: '',
        auto_pay: '',
      }
    }
  },
  methods: {
    getSchema: function (value) {
      this.ui_schema = value;
    },
    getCities() {
      Axios2.post('/divar/market/numbers/city', JSON.stringify({
        numbers: [this.schema.advertise.contact.phone]
      })).then((response) => {
        console.log(response)
        this.relatedCities = response.data.data
      })
    },
    getFields: function (val) {
      this.fields = val;
    },
    getCurrent: function (value) {
      this.current = value;
    },
    authenticate() {
      this.$modal.showLoading();
      $.ajax({
        url: `${url}/divar/check/title`,
        type: "POST",
        fn: this.authenticate,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
          "Content-type": 'application/json'
        },
        data: JSON.stringify({
          "title": this.schema.advertise['title'],
          "city": String(this.relatedCities.find((x) => x.id === this.schema.advertise.contact.phone).city),
          "category": this.schema.advertise.category
        }),
        msg: false,
        error: (data) => {
          if (data.status === 422) {
            this.$modal.error('خطا', 'لطفا اطلاعات فرم را کامل نمایید.')
          } else {
            this.$modal.error('خطا', 'عنوان مورد نظر قابل قبول نمی باشد.');
          }

        },
        success: (data) => {
          this.sendAds();
        }
      });

    },
    sendAds() {
      const data = this.schema;

      if (!this.$refs.inputs.validate() || !this.$refs.number.validate())
        return;
      if (data.advertise.images.length <= 0) {
        this.$modal.error('خطا!', 'حداقل یک عکس باید انتخاب کنید.');
        return;
      }

      if (data.available_at === "") {
        delete data.available_at;
      }

      if (data.expire_at === "") {
        delete data.expire_at;
      }
      if (data.advertise.location.neighborhood === "" || data.advertise.location.neighborhood === null || data.advertise.location.neighborhood === undefined)
        delete data.advertise.location.neighborhood;
      this.$modal.showLoading();
      $.ajax({
        url: `${url}/divar/market/send`,
        method: 'POST',
        fn: this.sendAds,
        headers: {
          AUTHORIZATION: Token,
          'Content-Type': 'application/json',
          ACCEPT: 'application/json'
        },
        data: JSON.stringify(data),
        msg: true,
        redirect: {path: '/adsList/myAdsList'}
      });
    },
  },
  mounted() {
    Bus.$on('category-current', (current) => {
      this.schema.advertise.category = current;
    });

    Bus.$on('contact', (value) => {
      this.schema.advertise.contact.chat_enabled = value.chat_enabled;
      this.schema.advertise.contact.hide_phone = value.hide_phone;
      this.schema.auto_pay = value.autoPay;
    });

    Bus.$on('selected_numbers', (value) => {
      this.schema.advertise.contact.phone = value;
      this.getCities(value)
    });

    Bus.$on('selectedImage', (value) => {
      this.schema.advertise.images = value;
    });

    Bus.$on('reload', (fields) => {
      this.fields = fields;
    });

    Bus.$on('times', (value) => {
      this.schema.available_at = value.times.starttime;
      this.schema.expire_at = value.times.endtime;
    });

    Bus.$on('national', (value) => {
      this.isNational = value
    });
  }

}
</script>

<style scoped>


</style>